<span class="aplayer-time-inner">
  - <span class="aplayer-ptime">{{ ptime }}</span> / <span class="aplayer-dtime">{{ dtime }}</span>
</span>



// WEBPACK FOOTER //
// ./src/components/Time/src/Time.html